import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

export class Behandlungsraum {
    behandlungsraum_id: number;
    raum_nr: string;
    name: string;
}

@Component({
    selector: 'kiene-heimtier-behandlungsraum-dialog',
    templateUrl: './heimtier-behandlungsraum-dialog.component.html',
    styleUrls: ['./heimtier-behandlungsraum-dialog.component.scss'],
})
export class HeimtierBehandlungsraumDialogComponent implements OnInit {
    raumNrCtrl = new FormControl(undefined);
    nameCtrl = new FormControl(undefined, [Validators.required]);

    constructor(
        public dialogRef: MatDialogRef<HeimtierBehandlungsraumDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: Behandlungsraum,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
        private api: KieneBackendApiService,
    ) {}

    ngOnInit(): void {
        if (this.data) {
            this.raumNrCtrl.setValue(this.data.raum_nr);
            this.nameCtrl.setValue(this.data.name);
        }
    }

    public save(): void {
        this.data.raum_nr = this.raumNrCtrl.value;
        this.data.name = this.nameCtrl.value;

        this.api.post(this.apiBaseUrl + 'behandlungsraum/update.php', this.data).subscribe({
            next: () => {
                this.dialogRef.close(this.data);
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Löschen des Behandlungsraums!', err);
            },
        });
    }
}
